
  import { Vue, Component, Prop } from "vue-property-decorator";
  import sourceData from "@/vetquest-data.json";
  import PageTitle from "@/components/PageTitle.vue";
  import { GuidelineService } from "@/services";

  @Component({
    name: "Page",
    components: { PageTitle }
  })
  export default class Page extends Vue {
    @Prop({ default: "guidelines" }) id!: string;

    page: any;
    isLoading = false;

    constructor() {
      super();
      this.page = {
        title: "",
        text: ""
      };
    }

    async created() {
      switch (this.id.toLowerCase()) {
        case "guidelines":
          this.page = await this.loadGuideLines();
          break;
        case "privacypolicy":
          this.page = sourceData.pages.PrivacyPolicy;
          break;
        case "information":
          this.page = sourceData.pages.Information;
          break;
        case "vetsearchandreferral":
          this.page = sourceData.pages.VetSearchAndReferral;
          break;
        default:
          this.page = sourceData.pages.Guidelines;
          break;
      }
    }

    async loadGuideLines() {
      this.isLoading = true;
      const { status, data } = await GuidelineService.GetGuildelines();
      this.isLoading = false;
      if (status === 200) {
        return {
          title: "Guidelines",
          text: data
        };
      }
      return { title: "", text: "" };
    }
  }
